import { useEffect, useState } from 'react'
import { BadgeCheck, MapPin, RefreshCw, ShieldAlert, XCircle } from 'lucide-react'
import { StatusPill } from '../components/StatusPill'
import { api } from '../lib/api'
import { formatDateTime } from '../lib/format'

export function VerificationLive() {
  const [rows, setRows] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState<string | null>(null)

  const reload = async () => {
    setLoading(true)
    try {
      setRows(await api.pendingVerification())
      setError('')
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { void reload() }, [])

  async function decide(id: string, decision: 'verified' | 'rejected') {
    setBusy(id)
    try {
      await api.verify(id, { decision })
      await reload()
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e))
    } finally {
      setBusy(null)
    }
  }

  return (
    <div className="page-stack">
      <section className="page-header-row">
        <div><h2>Verification queue</h2><p>Public evidence stays untrusted until a verifier accepts it.</p></div>
        <button className="button button--secondary" onClick={() => void reload()} disabled={loading}><RefreshCw size={17} /> Refresh</button>
      </section>

      {error && <section className="panel" role="alert"><div className="panel-heading"><div><span className="eyebrow">DATA UNAVAILABLE</span><h3>Could not load verification queue</h3></div><button className="button button--secondary" onClick={() => void reload()} disabled={loading}>Try again</button></div><p style={{ padding: '0 19px 17px', margin: 0 }}>{error}</p></section>}

      <section className="panel">
        <div className="panel-heading"><div><h3>{loading ? 'Loading observations…' : error ? '—' : `${rows.length} observation${rows.length === 1 ? '' : 's'} awaiting decision`}</h3></div><ShieldAlert size={20} /></div>
        {loading ? <div className="empty-state" role="status"><span>Loading verification queue…</span></div> : rows.length === 0 ? <div className="empty-state"><BadgeCheck size={30} /><strong>Queue clear</strong><span>There are no unverified observations.</span></div> : <div className="campaign-list">{rows.map((row) => <article className="campaign-row" key={row.id}>
          <div><div className="campaign-row__heading"><div><strong>{row.tree_code}</strong><span>{formatDateTime(row.observed_at)} · {row.source}{row.gps_accuracy_m != null ? ` · GPS ±${Math.round(row.gps_accuracy_m)}m` : ''}</span></div><StatusPill value={row.condition_reported} compact /></div>{row.note && <p>{row.note}</p>}{row.latitude != null && <span className="campaign-row__footer"><span><MapPin size={13} /> Evidence coordinates captured</span></span>}</div>
          <div className="hero-actions"><button disabled={busy === row.id} className="button button--primary button--small" onClick={() => void decide(row.id, 'verified')}><BadgeCheck size={16} /> Verify</button><button disabled={busy === row.id} className="button button--secondary button--small" onClick={() => void decide(row.id, 'rejected')}><XCircle size={16} /> Reject</button></div>
        </article>)}</div>}
      </section>
    </div>
  )
}
